import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils.js'

// 老带新支付状态
const INVITE_PAY_STATUS = new GenerateEnum({
  UN_PAY: {
    label: getLabelText({ key: 'remote.common.registered', text: '已注册' }) + ',' + getLabelText({ key: 'remote.common.unpaid', text: '未付费' }),
    value: '0'
  },
  PAIED: {
    label: getLabelText({ key: 'remote.common.registered', text: '已注册' }) + ',' + getLabelText({ key: 'remote.common.paymentCompleted', text: '已付费' }),
    value: '1'
  }
})

const inviteAwardType = new GenerateEnum({
  VOUCHER: {
    value: 1,
    label: getLabelText({ key: 'remote.common.coupons', text: '优惠券' })
  },
  AWARD_SCORE: {
    value: 2,
    label: getLabelText({ key: 'remote.common.bonusPoints', text: '奖励积分' })
  },
  CASH_VOUCHER: {
    value: 3,
    label: getLabelText({ key: 'remote.common.cashRedEnvelope', text: '现金红包' })
  }
})
// inviteAwardWay VOUCHER :0:代金券 PACKAGE :1:券包 SERVICE_VOUCHER :2:服务兑换券 FULL_REDUCTION :3:满减优惠券
const INVITE_AWARD_WAY = new GenerateEnum({
  VOUCHER: {
    label: getLabelText({ key: 'remote.common.voucher2', text: '代金券' }),
    value: '0',
    icon: 'icon-laodaixin-youhuiquan',
    pcIcon: 'laodaixin-youhuiquan'
  },
  PACKAGE: {
    label: getLabelText({ key: 'remote.common.couponBag', text: '券包' }),
    value: '1',
    icon: 'icon-laodaixin-quanbao',
    pcIcon: 'laodaixin-quanbao'
  },
  SERVICE_VOUCHER: {
    label: getLabelText({ key: 'remote.common.voucherForService', text: '服务兑换券' }),
    value: '2',
    icon: 'icon-laodaixin-duihuanquan',
    pcIcon: 'laodaixin-duihuanquan'
  },
  FULL_REDUCTION: {
    label: getLabelText({ key: 'remote.common.discountCoupon', text: '满减优惠券' }),
    value: '3',
    icon: 'icon-laodaixin-youhuiquan',
    pcIcon: 'laodaixin-youhuiquan'
  }
})

// REGISTER :1 老带新奖励积分发放方式枚举 ORDER_PAY :2 首单支付发放
const SCORE_AWARD_WAY = new GenerateEnum({
  REGISTER: {
    label: getLabelText({ key: 'remote.common.signUpForRewards', text: '注册奖励' }),
    value: 1
  },
  ORDER_PAY: {
    label: getLabelText({ key: 'remote.common.firstOrderPaymentReward', text: '首单支付奖励' }),
    value: 2
  }
})

// UNACTIVATED("0", "待激活"), UNUSED("1", "未使用");
const VOUCHER_INIT_STATUS = new GenerateEnum({
  UNACTIVATED: {
    label: getLabelText({ key: 'remote.common.toBeActivated', text: '待激活' }), // 注册并且下单才能获得
    value: '0'
  },
  UNUSED: {
    label: getLabelText({ key: 'remote.common.notUsed', text: '未使用' }), // 注册即可活动
    value: '1'
  }
})

export { INVITE_PAY_STATUS, INVITE_AWARD_WAY, inviteAwardType, SCORE_AWARD_WAY, VOUCHER_INIT_STATUS }



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/oldAndNew.js